<template>
  <div class="jy-uploader">
    <van-uploader
      v-if="capture"
      accept="image/*"
      capture="camera"
      :before-read="beforeRead"
      :max-count="1"
      v-model="fileList"
    />
    <van-uploader
      v-else
      accept="image/jpeg"
      :before-read="beforeRead"
      :max-count="1"
      v-model="fileList"
    />
  </div>
</template>

<script>
import Compressor from "compressorjs"
import { Toast } from "vant"
import { ref, toRefs } from "vue"
import { useStore } from "vuex"
export default {
  name: "JyUploader",
  props: {
    capture: {
      type: String,
      default: "",
    },
    schoolCode: {
      type: String,
      default: "",
    },
    isFaceCheck: {
      type: Boolean,
      default: false,
    },
    defaultFileList: {
      type: Array,
      default() {
        return []
      },
    },
    moduleName: {
      type: String,
      default: "visitor",
    },
  },
  setup(props, { emit }) {
    const store = useStore()

    const { schoolCode, isFaceCheck, defaultFileList, moduleName } =
      toRefs(props)

    const fileList = ref([...defaultFileList.value])

    const faceCheck = (params) => store.dispatch("common/faceCheck", params)

    const uploadOSS = (params) => store.dispatch("common/uploadOSS", params)

    const saveFileOSS = async (params) => {
      let { blob, moduleName } = params
      let uploadOSSPrams = {
        file: blob,
        moduleName,
      }
      let r = await uploadOSS(uploadOSSPrams)

      if (r.success) {
        let { id, name, url } = r.data
        let fileList = [{ id, name, url }]
        emit("upload", { id, name, url, fileList })
      } else {
        Toast.fail(r.message)
      }
    }

    const faceCheckServe = async (params) => {
      let { schoolCode, blob } = params
      // blob 转换成 file
      let files = new window.File([blob], blob.name, { type: blob.type })
      let form = new FormData()
      form.append("file", files)
      form.append("schoolCode", schoolCode)
      let faceCheckRes = await faceCheck(form)
      if (faceCheckRes.success) {
        saveFileOSS(params)
      } else {
        Toast.fail(faceCheckRes.message)
        return
      }
    }

    const beforeRead = (file) => {
      if (file.type !== "image/jpeg") {
        Toast("请上传 jpg 格式图片")
        return false
      }

      new Compressor(file, {
        quality: 0.2,
        maxWidth: 1920,
        maxHeight: 1080,
        success(result) {
          let params = {
            schoolCode: schoolCode.value,
            blob: result,
            moduleName: moduleName.value,
          }
          if (isFaceCheck.value) {
            faceCheckServe(params)
          } else {
            saveFileOSS(params)
          }
        },
        error(err) {
          Toast.fail(err.message)
        },
      })
      return true
    }
    return {
      beforeRead,
      fileList,
    }
  },
}
</script>

<style lang="less" scoped>
.jy-uploader {
}
</style>
